import { NegativeIcon, PositiveIcon } from "@datagame/ui";
import { motion, MotionValue, useMotionValue, useTransform } from "framer-motion";
import { useState } from "react";
import classNames from "classnames/bind";

import { CARD_COMMIT_X, CARD_OVERLAY_OPACITY } from "../../../../constants";

import styles from "./Overlay.module.scss";
import { useGameVisuals } from "../../../../contexts/gameVisuals";

const cx = classNames.bind(styles);

interface OverlayProps {
  currentX?: MotionValue<number>;
  overwrite?: "right" | "left";
  initialAnimation?: boolean;
  showIcons?: boolean;
}

export const Overlay = ({ currentX, overwrite, initialAnimation, showIcons }: OverlayProps) => {
  const [isSwipeRight, setIsSwipRight] = useState(overwrite === "right");
  const gameVisuals = useGameVisuals();
  const { positiveColor, negativeColor, iconSet } = gameVisuals ?? {};

  if (!currentX && !overwrite) {
    throw new Error("Either currentX or overwrite must be provided");
  }

  // We use conditional hook here because it depends on value comming from useMotionValue
  // so it will never be invalidated
  const x = currentX ?? useMotionValue(isSwipeRight ? CARD_COMMIT_X : -CARD_COMMIT_X);

  const overlayOpacity = useTransform(
    x,
    [-CARD_COMMIT_X, 0, CARD_COMMIT_X],
    [CARD_OVERLAY_OPACITY, 0, CARD_OVERLAY_OPACITY],
  );

  useTransform(x, (value) => {
    if (value > 0 && !isSwipeRight) {
      setIsSwipRight(true);
    } else if (value < 0 && isSwipeRight) {
      setIsSwipRight(false);
    }
  });

  const variants = {
    exit: {
      opacity: [0, CARD_OVERLAY_OPACITY],
    },
    none: {},
  };

  return (
    <motion.div
      className={styles.overlay}
      style={{
        opacity: overlayOpacity,
      }}
      variants={variants}
      animate={initialAnimation ? "exit" : "none"}
    >
      <motion.div
        className={cx("overlay", { right: isSwipeRight })}
        style={{ opacity: overlayOpacity, background: isSwipeRight ? positiveColor : negativeColor }}
      >
        {showIcons &&
          (isSwipeRight ? (
            <PositiveIcon iconSetKey={iconSet} className={styles.icon} />
          ) : (
            <NegativeIcon iconSetKey={iconSet} className={styles.icon} />
          ))}
      </motion.div>
    </motion.div>
  );
};

// {showIcons && (isSwipeRight ? <CheckIcon className={styles.icon} /> : <CloseIcon className={styles.icon} />)}
